var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"fid-card",attrs:{"flat":"","tile":""}},[(_vm.usePlayer)?_c('Player',{attrs:{"big":"","reason":_vm.itemReason,"vimeo-pictures":_vm.VimeoVideoPicturesInfo,"master":_vm.master}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }